import { createI18n } from 'vue-i18n';

import globalDeMessages from '../../../../i18n/de.json';
import deMessages from '../i18n/de.json';

const i18n = createI18n({
  legacy: false,
  locale: 'de-DE',
  fallbackLocale: 'de-DE',
  messages: {
    de: {
      ...globalDeMessages,
      ...deMessages,
      common: { ...globalDeMessages.common, ...deMessages.common },
      misc: { ...globalDeMessages.misc, ...deMessages.misc },
    },
  },
  numberFormats: {
    de: {
      currency: {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      },
    },
  },
});

export default i18n;
